<template>
    <div class="index">
      <div style="height: 80px"></div>
      <div class="main">
        <div class="title">
          <div class="sp1">便利店</div>
          <div class="sp2">CONVENIENCE STORE</div>
        </div>
        <div class="dess">成熟稳定的私有化电商系统，可<span style="color: #F40009">满足全场景</span>和垂直行业的个性化需求</div>
        <div class="content">
          <div class="box">
            <div class="img" style="overflow: hidden;">
              <img  src="@/assets/img/solition/qhy.png" alt="">
            </div>
            <div class="title1">全行业</div>
            <div class="des1">
              支持满足各垂直行业的数字化转型需求，打造具备行业特点的线上交易平台
            </div>
          </div>
          <div class="box">
            <div class="img" style="overflow: hidden;">
              <img  src="@/assets/img/solition/qcj.png" alt="">
            </div>
            <div class="title1">全场景</div>
            <div class="des1">
              支持各种业务场景实现，社交分销、企业内购、积分商城、直播电商、跨境电商
            </div>
          </div>
          <div class="box">
            <div class="img" style="overflow: hidden;">
              <img  src="@/assets/img/solition/qzd.png" alt="">
            </div>
            <div class="title1">全终端</div>
            <div class="des1">
              PC+H5+APP+全渠道小程序（微信、支付宝、头条、抖音、百度），抢占全网流量
            </div>
          </div>
        </div>
      </div>
      <div class="main" style="height: 730px">
        <div class="title">
          <div class="sp1">广告投放</div>
          <div class="sp2">ADVERTISING</div>
        </div>
        <div class="dess">没有创变，也就没法<span style="color: #F40009">与时俱进</span></div>
        <div class="content">
          <div class="left" style="width: 650px">
            <div>智能触摸屏</div>
            <div>智能触摸屏商用液晶终端是集先进的触控、工控、计算机等技术于一体，可实现互动媒体、
              互联网平台流量引流、产品互动广告、产品展示交互体验、行业应用推广及办公教学等领域，
              其中在新零售及新营销领域表现得尤为突出，商家可以根据不同的地域、场所，为不同的人投放广告。</div>
          </div>
          <div class="right">
            <img src="@/assets/img/solition/ggtfj.png" alt="">
          </div>
        </div>
      </div>
      <div class="main productBg" style="height: 850px">
        <div class="title">
          <div class="sp1">产品形态</div>
          <div class="sp2">PRODUCT FORM</div>
        </div>
        <div class="content" style="justify-content: center">
          <img src="@/assets/img/solition/gzp.png" alt="" style="margin-right: 160px">
          <div class="productRight">
            <div class="title2">格子铺</div>
            <div class="title3">简介</div>
            <div style="width: 98px;height: 10px;background: #FB8789;margin-bottom: 10px"></div>
            <div>与传统电商平台无缝对接，实现对已有商品的投放展示。亦可定制商城小程序，实现多屏投放，扫描二维码实现小程序下单</div>
            <div class="title3">优点</div>
            <div style="width: 98px;height: 10px;background: #FB8789;margin-bottom: 10px"></div>
            <div>通过智能触摸屏格子铺可快速浏览所有商品，点击可查看商品详情，通过扫描二维码跳转到相应的平台，实现产品引流的效果</div>
          </div>
        </div>
      </div>
      <div class="main" style="height: 540px;margin-top: 108px">
        <div class="content" style="justify-content: center;top: 0">
          <div class="productRight" style="margin-right: 160px">
            <div class="title2">自助取号</div>
            <div class="title3">简介</div>
            <div style="width: 98px;height: 10px;background: #FB8789;margin-bottom: 10px"></div>
            <div>餐饮商户在店门口放置智能触摸屏,可以替代传统的排号系统。屏幕上可以显示几人桌的排队的排队人数。当前叫号的号码。</div>
            <div class="title3">优点</div>
            <div style="width: 98px;height: 10px;background: #FB8789;margin-bottom: 10px"></div>
            <div>传统的餐饮店排队叫号都是通过取号发纸条，用户只能在门口才知道现在叫到哪个号了。</div>
          </div>
          <img src="@/assets/img/solition/zzqh.png" alt="">
        </div>
      </div>
      <div class="main" style="height: 650px">
        <div class="title">
          <div class="sp1">商城</div>
          <div class="sp2">SHOPPING MALL</div>
        </div>
        <div class="dess" style="margin-bottom: 150px">系统稳定高于一切，让商家经营<span style="color: #F40009">有保障</span></div>
        <div class="content">
          <div class="boxShop">
            <img src="@/assets/img/solition/hlw_images_xtym.png" alt="">
            <div class="boxShop1">
              <div class="sp1">提供系统源码</div>
              <div class="sp2">提供电商网站源码及独立部署,后期的开发与技术完全掌握在企业自己手上</div>
            </div>
          </div>
          <div class="boxShop">
            <img src="@/assets/img/solition/hlw_images_eckf.png" alt="">
            <div class="boxShop1">
              <div class="sp1">支持定制化/二次开发</div>
              <div class="sp2">结合企业实际要求和行业特性,全方位实现商城功能拓展及专属方案制定</div>
            </div>
          </div>
          <div class="boxShop">
            <img src="@/assets/img/solition/hlw_images_gx.png" alt="">
            <div class="boxShop1">
              <div class="sp1">系统不断更新</div>
              <div class="sp2">顺应互联网发展潮流,持续迭代更新,升级永无止境</div>
            </div>
          </div>
          <div class="boxShop">
            <img src="@/assets/img/solition/hlw_images_yzs.png" alt="">
            <div class="boxShop1">
              <div class="sp1">一站式服务</div>
              <div class="sp2">电商行业解决方案—站式服务,企业不懂技术也能轻松做电商</div>
            </div>
          </div>
        </div>
      </div>
      <div class="main" style="height: 888px">
        <div class="title">
          <div class="sp1">商城优势</div>
          <div class="sp2">ADVANTAGE</div>
        </div>
        <div class="dess" style="margin-bottom: 100px">商城<span style="color: #F40009">类别多样</span></div>
        <div class="category">
          <div class="col">
            <div>221<span>万</span></div>
            <div>商家信赖之选</div>
          </div>
          <div class="col">
            <div>150<span>个</span></div>
            <div>覆盖行业和类目</div>
          </div>
          <div class="col">
            <div>３<span>亿</span></div>
            <div>在售商品数</div>
          </div>
          <div class="col">
            <div>325<span>亿</span></div>
            <div>商家2019年交易额</div>
          </div>
          <div class="col">
            <div>10<span>万/秒</span></div>
            <div>订单处理速度</div>
          </div>
        </div>
        <div class="content" style="top: 380px;">
          <div class="shopBox">
            <img src="@/assets/img/solition/yrb.png" alt="">
            <div class="shopTitle">e茸宝</div>
            <div class="shopDes">e茸宝APP是围绕食用菌产业，以“中国领先的菌菇交易平台”的发展理念，依托互联网、云计算、大数据等新一代电子信息技术，紧抓行业建设空白与痛点，采用B2B 模式</div>
            <div class="foot">
              <div>APP</div>
              <div>食用菌</div>
            </div>
          </div>
          <div class="shopBox">
            <img src="@/assets/img/solition/dwyh.png" alt="">
            <div class="shopTitle">东吴壹号</div>
            <div class="shopDes">东吴壹号，致力于打造线上线下一体化文化产品分享、品鉴、交流的第三空间，以文化产品的兴趣者为客户群体，整合文化产品的创造者资源</div>
            <div class="foot">
              <div>小程序</div>
              <div>茶叶文化</div>
            </div>
          </div>
          <div class="shopBox">
            <img src="@/assets/img/solition/tl.png" alt="">
            <div class="shopTitle">途礼</div>
            <div class="shopDes">途礼小程序是一款“带得走的城市印记”的旅游小程序，旅途看到好东西，总想买点给朋友，但不知道地址好尴尬！还好有途礼，一键下单，发送给微信好友</div>
            <div class="foot">
              <div>小程序</div>
              <div>旅游购物</div>
            </div>
          </div>
        </div>
      </div>
      <div style="height: 100px"></div>
      <div class="main" style="height: 1400px">
        <div class="title">
          <div class="sp1">营销推广</div>
          <div class="sp2">EXTENSION</div>
        </div>
        <div class="dess">抓住流量<span style="color: #F40009">获取销量</span></div>
        <div class="content" style="justify-content: space-between">
          <Row type="flex" justify="center" align="middle">
            <i-col span="10">
              <div class="left">
                <div>多渠道推广引流，获客更高效</div>
                <div>支持官网、公众号、小程序、广告等全渠道营销触点构建，以强大完善的交互能力深度连接客户，提升营销触达效率</div>
              </div>
            </i-col>
            <i-col span="4"></i-col>
            <i-col span="10"><img src="@/assets/img/solition/hlw_images_.png" alt="" style="width: 100%"></i-col>
          </Row>
        </div>
        <div class="content" style="justify-content: space-between">
          <Row type="flex" justify="center" align="middle" style="width: 100%">
            <i-col span="10">
              <img src="@/assets/img/solition/hlw_images_dqd.png" alt="" style="width: 100%">
            </i-col>
            <i-col span="4"></i-col>
            <i-col span="10">
              <div class="left">
                <div>多种营销玩法，提升成交</div>
                <div>丰富的营销功能，利用社群带来源源不断的流量和业务增长</div>
              </div>
            </i-col>
          </Row>
        </div>
      </div>
    </div>
</template>

<script>
    /**
     *
     * @Author zzl
     * @Date 2020/11/23 17:12.
     */

    export default {
        mounted() {
          window.scrollTo(0,0);
        },
        components: {},
        props: {},
        data() {
            return {}
        },
        computed: {},
        methods: {},
        watch: {},
        filters: {},
        beforeDestroy() {

        }
    }
</script>

<style lang="less" scoped>
.index{
  width: 100%;
  min-width: 1920px;
  .main{
    width: 100%;
    height: 610px;
    margin-top: 40px;
    .title {
      position: relative;
      width: 100%;
      height: 110px;
      text-align: center;

      .sp1 {
        width: 100%;
        text-align: center;
        position: absolute;
        font-size: 34px;
        font-family: Source Han Sans CN;
        font-weight: 300;
        color: #232330;
        bottom: 0;
        z-index: 9;
      }

      .sp2 {
        width: 100%;
        text-align: center;
        position: absolute;
        font-size: 90px;
        font-family: Source Han Sans CN;
        font-weight: 800;
        color: #F6F6F6;
      }
    }
    .dess{
      text-align: center;
      width: 100%;
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 300;
      color: #333333;
      margin-top: 20px;
    }
    .category{
      width: 1300px;
      margin: 40px auto;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .col{
        display: flex;
        flex-direction: column;
        div:first-child{
          text-align: center;
          font-size: 32px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #232330;
          span {
            font-size:20px;
          }
        }
        div:last-child{
          font-size: 17px;
          font-family: Source Han Sans CN;
          font-weight: 300;
          color: #333333;
        }
      }
    }
    .content{
      width: 1300px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin: 90px auto 0;
      .box{
        width: 300px;
        height: 255px;
        background: #FFFFFF;
        box-shadow: 0px 5px 10px 0px rgba(35, 35, 48, 0.05);
        border-radius: 15px;
        position: relative;
        overflow: hidden;
        .img{
          width: 100%;
          height: 178px;
          position: absolute;
          top: 0;
          left: 0;

        }
        .img img{
          width: 100%;
          height: 100%;
          transition: all .8s ease 0s;
          -webkit-transition: all .8s ease 0s;
        }
        .title1{
          height: 36px;
          line-height: 36px;
          font-size: 24px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #FFFFFF;
          background: rgba(0,0,0,0.5);
          position: absolute;
          top: 142px;
          left: 0;
          width: 100%;
          text-align: center;
        }
        .des1{
          width: 210px;
          height: 80px;
          position: absolute;
          bottom: 0px;
          padding: 6px 0;
          box-sizing: border-box;
          display: flex;
          justify-content: center;
          align-items: center;
          left: calc(50% - 105px);
          font-size: 15px;
          font-family: Source Han Sans CN;
          font-weight: 300;
          color: #282331;
          text-align: center;
          line-height: 18px;
        }
      }
      .box:hover{
        .img img{
          width: 120%;
          height: 120%;
          margin-left: -10%;
          margin-top: -10%;
        }
      }
      .left{
        /*width: 700px;*/
        div:first-child{
          font-size: 24px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #333333;
          margin-bottom: 30px;
        }
        div:last-child{
          font-size: 20px;
          font-family: Source Han Sans CN;
          font-weight: 300;
          color: #333333;
        }
      }

      .productRight{
        width: 509px;
        height: 100%;
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: 300;
        color: #333333;
        line-height: 40px;
        display: flex;
        flex-direction: column;
        .title2{

          font-size: 30px;
          font-family: Source Han Sans CN;
          font-weight: 600;
          color: #333333;
        }
        .title3{
          font-size: 24px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #333333;
          line-height: 40px;
          margin-bottom: 12px;
          margin-top: 30px;
        }
      }
      .shopBox{
        width: 380px;
        height: 500px;
        background: #FFFFFF;
        border: 1px solid #EEEEEE;
        box-shadow: 0px 5px 10px 0px rgba(35, 35, 48, 0.05);
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        img{
          width: 86px;
          height: 86px;
          margin-top: 57px;
          /*position: absolute;*/
          /*top: -64px;*/
          /*left: calc(50% - 64px);*/
        }
        .shopTitle{
          font-size: 24px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #333333;
          margin-top: 50px;
        }
        .shopDes{
          width: 280px;
          height: 287px;
          font-size: 18px;
          font-family: Source Han Sans CN;
          font-weight: 300;
          color: #333333;
          text-align: justify;
          margin-top: 30px;
        }
        .foot{
          width: 100%;
          display: flex;
          margin-bottom: 30px;
          flex-direction: row;
          justify-content: flex-end;
          padding-right: 30px;
          box-sizing: border-box;
          div{
            width: 95px;
            text-align: center;
            height: 33px;
            line-height: 33px;
            background: #FFFFFF;
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 300;
            color: #040000;
            border: 1px solid #FFFFFF;
            box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
            margin-right: 10px;
          }
        }
      }
      .boxShop{
        width: 288px;
        height: 272px;
        background: #FFFFFF;
        box-shadow: 0px 5px 10px 0px rgba(35, 35, 48, 0.05);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .boxShop1{
          height: 60%;
        }
        img{
          width: 150px;
          margin: -50px auto 30px;
          display: block;
        }
        .sp1{
          width: 100%;
          text-align: center;
          font-size: 24px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #333333;
          margin-bottom: 10px;
        }
        .sp2{
          width: 235px;
          margin: 0 auto;
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: 300;
          color: #282331;
          line-height: 30px;
          opacity: 0.7;
          text-align: center;
        }
      }
    }
  }
  .productBg{
    /*background: url("~@/assets/img/solition/bg.png") no-repeat;*/
    /*background-position: bottom;*/
  }
}
</style>
